// extracted by mini-css-extract-plugin
export default {"titleCell":"LeftFilterTitleCell_titleCell__rQYrZ"};